export default class Base64Deriver {
  static decodeNumber(data) {
    if (typeof data !== 'string') {
      return;
    }

    let decoded;

    /* istanbul ignore else */
    if (__SERVER__) {
      decoded = Buffer.from(data, 'base64').toString('ascii');
    } else {
      decoded = atob(data);
    }

    if (/^\d+$/.test(decoded)) {
      return parseInt(decoded, 10);
    }
  }

  static encode(data) {
    // Only non-extended ASCII is supported for strings, across node/browser.
    const isValidString = typeof data === 'string' && /^[\x00-\x7F]*$/.test(data); // eslint-disable-line no-control-regex
    // NaN, +Infinity and -Infinity are type 'number' as well, we want to ignore those to avoid surprises.
    const isValidNumber = typeof data === 'number' && Number.isFinite(data);

    if (!(isValidString || isValidNumber)) {
      return;
    }

    let encoded;

    /* istanbul ignore else */
    if (__SERVER__) {
      encoded = Buffer.from(String(data)).toString('base64');
    } else {
      encoded = btoa(data);
    }

    return encoded;
  }
}
